module.exports = __webpack_public_path__ + "img/online.6972136c.png";